import { render, staticRenderFns } from "./relation-image.vue?vue&type=template&id=62371ace&"
import script from "./relation-image.vue?vue&type=script&lang=js&"
export * from "./relation-image.vue?vue&type=script&lang=js&"
import style0 from "./relation-image.vue?vue&type=style&index=0&id=62371ace&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports